module.exports = __webpack_public_path__ + "img/solution3.5b1a8153.png";